<script>
export default {
  name: "customProduct",
  props:{
    productList:{
      default: () => {
        return []
      }
    }
  },
  methods:{
    routerDetail(row){
      this.$router.push({
        path: '/integralProductDetails',
        query: {
          productId: row.id
        }
      })
    }
  }
}
</script>

<template>
  <div class="customProduct">
    <div class="items" @click="routerDetail(item)" v-for="(item, index) in productList" :key="index">
      <img class="banner" :src="item.coverImage" alt="" >
      <div class="van-ellipsis pd-8 title">{{item.name}}</div>
      <div class="flex-between pd-8 tips ">
        <div>库存:{{item.stock}}</div>
        <div>已兑换:{{item.sellCount || 0}}</div>
      </div>
      <div class="flex-between pd-8 money">
        <div class="flex-center left">
          <img  src="@/assets/img/home/integral/money.png" alt="">
          {{item.price}}安币
        </div>
        <div class="flex-center">
          <van-button round size="mini" color="linear-gradient(to right, #ff6034, #ee0a24)">
            立刻兑换
          </van-button>
        </div>
      </div>
    </div>

  </div>
</template>

<style scoped lang="scss">
.customProduct {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  .items {
    width: 164px;
    background: #fff;
    margin-bottom: 12px;
    box-shadow: 0 4px 16px 2px rgba(0, 0, 0, 0.06);
    //margin-right: 10px;
    border-radius: 12px;
    padding-bottom: 6px;
    box-sizing: border-box;
    .banner{
      width:164px;
      height: 180px;

    }
    .title{
      font-weight: bold;
      color: #333333;
    }
    .tips{
      color: #999999;
    }
    .money{
      .left{
        color: #FF5733;
        font-weight: bold;
      }
      img{
        width: 15px;
        margin-right: 4px;
      }
    }
  }
}

</style>